import styled from "styled-components";
import * as variables from "../../styles/variables";

export const Container = styled.footer`
  width: 100%;

  padding: 20px 0 40px 0;

  display: flex;
  flex-direction: column;
  align-items: center;

  background-color: ${variables.DARK_GREY};
`;
